<template>
    <div id="assinatura-do-contrato" class="assinatura-do-contrato">
        <div class="container_pequeno container_com-fundo container_com-margem u-padding-media">
            <loading :ativo="loading.visivel" :mensagem="loading.mensagem" />
            <div class="grade__linha grade__linha_alinhar-vertical-ao-topo">
                <div class="grade__coluna grade__coluna_3">
                    <div class="titulo titulo_grande u-margem-inferior-pequena">
                        Filtros
                    </div>
                </div>
            </div>
            <div class="grade__linha u-margem-inferior-media">
                <div class="grade__coluna grade__coluna_6">
                    <label class="formulario__label" for="nome">Nome</label>
                    <input name="nome" type="text" id="nome" class="formulario__input" placeholder="Nome"
                        v-model="filtro.nome" />
                </div>
                <div class="grade__coluna grade__coluna_3">
                    <label class="formulario__label" for="cpf">CPF</label>
                    <input name="cpf" type="text" id="cpf" class="formulario__input" placeholder="CPF"
                        v-mask="'999.999.999-99'" v-model="filtro.cpf" />
                </div>
                <div class="grade__coluna grade__coluna_3">
                    <label class="formulario__label" for="dataDeAssinatura">Data de assinatura
                        <span class="tooltips">
                            <i class="far fa-info-circle" aria-hidden="true"></i>
                            <span class="conteudo tooltip-top">Data em que o contrato foi assinado
                            </span>
                        </span>
                    </label>
                    <input id="dataDeAssinatura" class="formulario__input" type="date"
                        v-model="filtro.dataDeAssinaturaDoContrato" />
                </div>
            </div>
            <div class="grade__linha_alinhar-horizontal-direita formulario-button">
                <button type="button"
                    class="botao botao_cor-terciaria botao_contorno botao_medio u-margem-direita-media"
                    :disabled="!existeAlgumFiltroPreenchido" @click="limparFiltros">Limpar</button>
                <button type="button" class="botao botao_cor-terciaria botao_medio u-margem-direita-pequena"
                    :disabled="!existeAlgumFiltroPreenchido"
                    @click="obterSolicitacoes(this.paginaAtual)">Pesquisar</button>
            </div>
            <hr class="u-margem-superior-grande u-margem-inferior-grande"
                v-if="existemSolicitacoesParaAssinaturaDoContrato">
            <div class="grade__linha u-margem-inferior-media" v-if="existemSolicitacoesParaAssinaturaDoContrato">
                <div class="grade__coluna grade__coluna_6">
                    <div class="titulo titulo_grande u-margem-inferior-pequena">
                        Lista de contratos
                    </div>
                </div>
            </div>
            <div class="grade__linha u-margem-superior-pequena"
                v-if="foiRealizadaAlgumaPesquisa && !existemSolicitacoesParaAssinaturaDoContrato">
                <div class="grade__coluna grade__coluna_12">
                    <div class="estado-vazio">
                        <i class="far fa-align-slash estado-vazio__icone"></i>
                        <h2 class="estado-vazio__titulo">Nenhum resultado encontrado</h2>
                        <p class="estado-vazio__texto">Você pode buscar solicitações pelo <strong>nome</strong>,
                            <strong>CPF</strong> ou pela <strong>data de assinatura</strong>.
                        </p>
                    </div>
                </div>
            </div>
            <div class="grade__linha" v-if="existemSolicitacoesParaAssinaturaDoContrato">
                <div class="grade__coluna grade__coluna_12">
                    <table class="tabela tabela_listrada tabela_com-largura-total">
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th class="u-texto-alinhado-ao-centro">CPF</th>
                                <th class="u-texto-alinhado-ao-centro">Data de assinatura
                                    <span class="tooltips">
                                        <i class="far fa-info-circle" aria-hidden="true"></i>
                                        <span class="conteudo tooltip-top">Data em que o contrato foi assinado</span>
                                    </span>
                                </th>
                                <th class="u-texto-alinhado-ao-centro">Etapa</th>
                                <th class="u-texto-alinhado-ao-centro">Açoes</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="solicitacao of solicitacoes" :id="solicitacao.Id">
                                <td>{{ solicitacao.Nome }}</td>
                                <td class="u-texto-alinhado-ao-centro">{{ solicitacao.Cpf }}</td>
                                <td class="u-texto-alinhado-ao-centro">{{ solicitacao.DataDeAssinaturaDoContrato }}</td>
                                <td class="u-texto-alinhado-ao-centro">
                                    <div
                                        :class="['tags', obterClasseCssDaEtapaDoContrato(solicitacao.EtapaDoContrato)]">
                                        {{ solicitacao.EtapaDoContrato }}
                                    </div>
                                </td>
                                <td class="u-texto-alinhado-ao-centro">
                                    <div class="dropdown dropdown_direita">
                                        <button
                                            class="botao botao_cor-terciaria botao_com-icone-para-direita botao_sem-preenchimento botao_pequeno"
                                            aria-haspopup="true">
                                            Ações <i class="far fa-chevron-down"></i>
                                        </button>
                                        <ul class="dropdown__lista" aria-label="Submenu">
                                            <li class="dropdown__item">
                                                <button type="button"
                                                    class="no-print botao botao_cinza botao_com-icone-para-esquerda botao_sem-preenchimento botao_pequeno largura-maxima u-texto-alinhado-a-esquerda"
                                                    @click="baixarCertificado(solicitacao)">
                                                    <i class="fal fa-download" aria-hidden="true"></i> Baixar
                                                    certificado
                                                </button>
                                            </li>
                                            <li class="dropdown__item">
                                                <button type="button"
                                                    :class="['no-print botao botao_cinza botao_com-icone-para-esquerda botao_sem-preenchimento botao_pequeno largura-maxima u-texto-alinhado-a-esquerda', solicitacao.PermiteAssinaturaDoContrato ? '' : 'u-desabilitado']"
                                                    @click="abrirModalDeAssinaturaDoContrato(solicitacao)">
                                                    <i class="fal fa-file-signature" aria-hidden="true"></i> Assinar
                                                    contrato
                                                </button>
                                            </li>
                                            <li class="dropdown__item">
                                                <button type="button"
                                                    :class="['no-print botao botao_cinza botao_com-icone-para-esquerda botao_sem-preenchimento botao_pequeno largura-maxima u-texto-alinhado-a-esquerda', solicitacao.PermiteRegistroDoContrato ? '' : 'u-desabilitado']"
                                                    @click="abrirModalDeRegistroDoContrato(solicitacao)">
                                                    <i class="fal fa-file-contract" style="margin-right: 12px;"></i>
                                                    Registrar contrato
                                                </button>
                                            </li>
                                            <li class="dropdown__item">
                                                <button type="button"
                                                    :class="['no-print botao botao_cinza botao_com-icone-para-esquerda botao_sem-preenchimento botao_pequeno largura-maxima u-texto-alinhado-a-esquerda', solicitacao.PermiteCancelamentoDaSolicitacao ? '' : 'u-desabilitado']"
                                                    @click="abrirModalDeCancelamento(solicitacao)">
                                                    <i class="fal fa-ban" aria-hidden="true"></i> Cancelar solicitação
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="grade__linha" v-if="existemSolicitacoesParaAssinaturaDoContrato">
                <div class="grade__coluna grade__coluna_12">
                    <paginacao @paginar="obterSolicitacoes" :paginaAtual="paginaAtual" :totalDePaginas="totalDePaginas"
                        :totalDeRegistros="totalDeRegistros" />
                </div>
            </div>
            <modal v-if="modalDeAssinaturaDoContratoEstaVisivel" @close="fecharModalDeAssinaturaDoContrato">
                <form @submit.prevent="assinarContrato">
                    <h3 class="titulo titulo_medio u-margem-inferior-media">Informar data da assinatura do contrato</h3>
                    <hr class="u-margem-inferior-media">
                    <div class="grade__linha grade__linha_alinhar-horizontal-centro u-margem-inferior-media">
                        <div role="alert" class="grade__coluna mensagem mensagem_cor-atencao u-sem-margem"
                            id="divMensagemDeLiberacao" style="z-index: 0">
                            <i class="far fa-exclamation-circle mensagem__icone"></i>
                            <div class="mensagem__conteudo">
                                <h2 class="mensagem__titulo">Fique atento:</h2>
                                <p class="mensagem__texto">Essa ação não poderá ser desfeita.</p>
                            </div>
                        </div>
                    </div>
                    <div class="grade__linha">
                        <div class="grade__coluna grade__coluna_12 u-sem-padding">
                            <span>Nome: {{ solicitacaoSelecionada.nome }}</span>
                        </div>
                    </div>
                    <div class="grade__linha">
                        <div class="grade__coluna grade__coluna_12 u-sem-padding">
                            <span>CPF: {{ solicitacaoSelecionada.cpf }}</span>
                        </div>
                    </div>
                    <div class="grade__linha u-margem-superior-media">
                        <div class="grade__coluna grade__coluna_6 u-sem-padding">
                            <label class="formulario__label" for="dataDeAssinaturaInformada">Data da assinatura</label>
                            <input id="dataDeAssinaturaInformada" class="formulario__input" type="date"
                                v-model="solicitacaoSelecionada.dataDeAssinaturaDoContrato" required />
                        </div>
                    </div>
                    <div class="grade__linha u-margem-superior-media">
                        <div class="u-exibir-em-linha-flexivel">
                            <input type="checkbox" class="formulario__checkbox-marcador"
                                id="declaracaoDeResponsabilidade" v-model="ehResponsavelPelaAssinaturaDoContrato">
                            <label class="formulario__label" for="declaracaoDeResponsabilidade">
                                <strong>Declaro, sob minha responsabilidade, que a pessoa selecionada e a data de
                                    assinatura estão corretas</strong>
                            </label>
                        </div>
                    </div>
                    <hr class="u-margem-superior-media">
                    <div class="grade__linha_alinhar-horizontal-direita formulario-button u-margem-superior-grande">
                        <button type="button" @click="fecharModalDeAssinaturaDoContrato"
                            class="botao botao_cinza botao_medio u-margem-direita-pequena">Cancelar</button>
                        <button type="submit" class="botao botao_cor-terciaria botao_medio"
                            :class="{ 'is-loading': loading.visivel }"
                            :disabled="!ehResponsavelPelaAssinaturaDoContrato">Confirmar</button>
                    </div>
                </form>
            </modal>
            <modal v-if="modalDeRegistroDoContratoEstaVisivel" @close="fecharModalDeRegistroDoContrato">
                <form @submit.prevent="registrarContrato">
                    <h3 class="titulo titulo_medio u-margem-inferior-media">Informar registro do contrato</h3>
                    <hr class="u-margem-inferior-media">
                    <div class="grade__linha grade__linha_alinhar-horizontal-centro u-margem-inferior-media">
                        <div role="alert" class="grade__coluna mensagem mensagem_cor-atencao u-sem-margem"
                            id="divMensagemDeLiberacao" style="z-index: 0">
                            <i class="far fa-exclamation-circle mensagem__icone"></i>
                            <div class="mensagem__conteudo">
                                <h2 class="mensagem__titulo">Fique atento:</h2>
                                <p class="mensagem__texto">Essa ação não poderá ser desfeita.</p>
                            </div>
                        </div>
                    </div>
                    <div class="grade__linha">
                        <div class="grade__coluna grade__coluna_12 u-sem-padding">
                            <span>Nome: {{ solicitacaoSelecionada.nome }}</span>
                        </div>
                    </div>
                    <div class="grade__linha">
                        <div class="grade__coluna grade__coluna_12 u-sem-padding">
                            <span>CPF: {{ solicitacaoSelecionada.cpf }}</span>
                        </div>
                    </div>
                    <div class="grade__linha u-margem-superior-media">
                        <div class="grade__coluna grade__coluna_6 u-sem-padding">
                            <label class="formulario__label" for="dataDeRegistroInformada">Data de registro</label>
                            <input id="dataDeRegistroInformada" class="formulario__input" type="date"
                                v-model="solicitacaoSelecionada.dataDeRegistroDoContrato" required />
                        </div>
                    </div>
                    <div class="grade__linha u-margem-superior-media">
                        <div class="u-exibir-em-linha-flexivel">
                            <input type="checkbox" class="formulario__checkbox-marcador"
                                id="declaracaoDeResponsabilidadeDoRegistroDoContrato"
                                v-model="ehResponsavelPeloRegistroDoContrato">
                            <label class="formulario__label" for="declaracaoDeResponsabilidadeDoRegistroDoContrato">
                                <strong>Declaro, sob minha responsabilidade, que a pessoa selecionada e a data de
                                    registro estão corretas.</strong>
                            </label>
                        </div>
                    </div>
                    <hr class="u-margem-superior-media">
                    <div class="grade__linha_alinhar-horizontal-direita formulario-button u-margem-superior-grande">
                        <button type="button" @click="fecharModalDeRegistroDoContrato"
                            class="botao botao_cinza botao_medio u-margem-direita-pequena">Cancelar</button>
                        <button type="submit" class="botao botao_cor-terciaria botao_medio"
                            :class="{ 'is-loading': loading.visivel }"
                            :disabled="!ehResponsavelPeloRegistroDoContrato">Confirmar</button>
                    </div>
                </form>
            </modal>
            <modal v-if="modalDeCancelamentoEstaVisivel" @close="fecharModalDeCancelamento">
                <form @submit.prevent="cancelarSolicitacao" class="formulario">
                    <h3 class="titulo titulo_medio u-margem-inferior-media">Cancelar solicitação</h3>
                    <hr class="u-margem-inferior-media">
                    <label for="justificativa">Motivo do cancelamento</label>
                    <textarea v-model="justificativa" name="justificativa" id="justificativa" cols="30" rows="8"
                        class="input u-margem-inferior-media" placeholder="Descreva o motivo do cancelamento"
                        required></textarea>
                    <div class="grade__linha_alinhar-horizontal-direita formulario-button">
                        <button type="button" @click="fecharModalDeCancelamento"
                            class="botao botao_cinza botao_medio u-margem-direita-pequena">Cancelar</button>
                        <button type="submit" class="botao botao_cor-terciaria botao_medio" :disabled="!justificativa"
                            :class="{ 'is-loading': loading.visivel }">Confirmar</button>
                    </div>
                </form>
            </modal>
            <MensagemFlutuante :mensagemVisivel="mensagemVisivel" :titulo="tituloMensagem" :estilo="estiloMensagem"
                :texto="textoMensagem" @close="fecharMensagem" />
        </div>
    </div>
</template>

<script>
import AwesomeMask from "awesome-mask";
import Paginacao from "../../shared/Paginacao";
import Loading from '../../shared/Loading';
import MensagemFlutuante from '../../shared/MensagemFlutuante';
import Modal from '../../shared/Modal';
import Download from "../../../utils/downloadDeArquivos.js";

export default {
    directives: { mask: AwesomeMask },
    components: { Paginacao, Loading, MensagemFlutuante, Modal },
    computed: {
        existeAlgumFiltroPreenchido() {
            return !(this.filtro.nome == null || this.filtro.nome.trim().length === 0) ||
                !(this.filtro.cpf == null || this.filtro.cpf.trim().length === 0) ||
                !(this.filtro.dataDeAssinaturaDoContrato == null || this.filtro.dataDeAssinaturaDoContrato.trim().length === 0);
        },
        existemSolicitacoesParaAssinaturaDoContrato() {
            return this.solicitacoes && this.solicitacoes.length > 0;
        }
    },
    data() {
        return {
            paginaAtual: 1,
            totalDePaginas: null,
            totalDeRegistros: null,
            loading: { visivel: false },
            mensagemVisivel: false,
            textoMensagem: '',
            estiloMensagem: '',
            tituloMensagem: '',
            solicitacoes: [],
            modalDeAssinaturaDoContratoEstaVisivel: false,
            modalDeCancelamentoEstaVisivel: false,
            ehResponsavelPelaAssinaturaDoContrato: false,
            modalDeRegistroDoContratoEstaVisivel: false,
            ehResponsavelPeloRegistroDoContrato: false,
            justificativa: '',
            foiRealizadaAlgumaPesquisa: false,
            filtro: {
                nome: '',
                cpf: '',
                dataDeAssinaturaDoContrato: null
            },
            solicitacaoSelecionada: {
                id: null,
                nome: '',
                cpf: '',
                dataDeAssinaturaDoContrato: null
            }
        };
    },
    methods: {
        obterSolicitacoes(paginaAtual) {
            let url = 'GerenciadorDeContrato/Filtrar';
            let filtroDeSolicitacoesParaAssinaturaDoContratoDto = {
                nome: this.filtro.nome,
                cpf: this.filtro.cpf,
                dataDeAssinaturaDoContrato: this.filtro.dataDeAssinaturaDoContrato,
                pagina: paginaAtual
            };

            this.exibirCarregamento();
            this.$api.post(url, filtroDeSolicitacoesParaAssinaturaDoContratoDto).then((response) => {
                this.solicitacoes = response.data.Modelo;
                this.paginaAtual = response.data.PaginaAtual;
                this.totalDePaginas = response.data.TotalDePaginas;
                this.totalDeRegistros = response.data.TotalDeRegistros;
            }).catch((error) => {
                this.tratarErro(error);
            }).finally(() => {
                this.esconderCarregamento();
                this.foiRealizadaAlgumaPesquisa = true;
            });
        },
        assinarContrato() {
            let solicitacaoId = this.solicitacaoSelecionada.id;
            let url = `/GerenciadorDeContrato/${solicitacaoId}/AssinarContratoDoMcmvCidades`;
            let parametrosParaAssinaturaDoContrato = {
                dataDeAssinatura: this.solicitacaoSelecionada.dataDeAssinaturaDoContrato
            };

            this.exibirCarregamento('Só um momento, estamos registrando a assinatura do contrato');
            this.$api.post(url, parametrosParaAssinaturaDoContrato).then(() => {
                this.exibirMensagemDeSucesso('Data de assinatura salva com sucesso!');
                this.fecharModalDeAssinaturaDoContrato();
                this.limparSolicitacaoSelecionada();
                this.ehResponsavelPelaAssinaturaDoContrato = false;
                this.obterSolicitacoes(this.paginaAtual);
            }).catch((error) => {
                this.tratarErro(error);
                this.esconderCarregamento();
            });
        },
        registrarContrato() {
            let solicitacaoId = this.solicitacaoSelecionada.id;
            let url = `/GerenciadorDeContrato/${solicitacaoId}/RegistrarContratoDoMcmvCidades`;
            let parametrosParaRegistroDoContrato = {
                dataDeRegistro: this.solicitacaoSelecionada.dataDeRegistroDoContrato
            };

            this.exibirCarregamento('Só um momento, estamos registrando o contrato');
            this.$api.post(url, parametrosParaRegistroDoContrato).then(() => {
                this.exibirMensagemDeSucesso('O registro foi realizado com sucesso!');
                this.fecharModalDeRegistroDoContrato();
                this.limparSolicitacaoSelecionada();
                this.ehResponsavelPelaAssinaturaDoContrato = false;
                this.obterSolicitacoes(this.paginaAtual);
            }).catch((error) => {
                this.tratarErro(error);
                this.esconderCarregamento();
            });
        },
        cancelarSolicitacao() {
            let solicitacaoId = this.solicitacaoSelecionada.id;
            let urlDeCancelamentoDeSolicitacao = `/solicitacao/McmvCidades/${solicitacaoId}/Cancelar`;
            this.exibirCarregamento('Só um momento, estamos cancelando a solicitação');
            this.$api.post(urlDeCancelamentoDeSolicitacao, { Justificativa: this.justificativa }).then(() => {
                this.exibirMensagemDeSucesso('A solicitação foi cancelada com sucesso');
                this.fecharModalDeCancelamento();
                this.limparSolicitacaoSelecionada();
                this.obterSolicitacoes(this.paginaAtual);
            }).catch((error) => {
                this.tratarErro(error);
                this.esconderCarregamento();
            });
        },
        baixarCertificado(solicitacao) {
            let download = new Download();
            const url = `/solicitacao/McmvCidades/${solicitacao.Id}/BaixarCertificado`;
            this.exibirCarregamento();
            download.realizarDownloadDeDocumentosComTratamentoDeErro('GET', url, {},
                () => this.executarAcoesAposBaixarCertificado(),
                () => this.executarAcoesQuandoOcorrerErroAoBaixarCertificado());
        },
        executarAcoesAposBaixarCertificado() {
            this.exibirMensagemDeSucesso("Certificado baixado com sucesso!");
            this.esconderCarregamento();
        },
        executarAcoesQuandoOcorrerErroAoBaixarCertificado() {
            this.exibirMensagemDeErro("Não foi possível baixar o certificado, tente novamente ou contate o suporte");
            this.esconderCarregamento();
        },
        exibirCarregamento(mensagem) {
            this.loading.visivel = true;
            this.loading.mensagem = mensagem;
        },
        esconderCarregamento() {
            this.loading.visivel = false;
            this.loading.mensagem = null;
        },
        tratarErro(error) {
            const internalServerError = 500;
            const mensagensDeErro = error.response.status != internalServerError ? error.response.data.Message : '';
            let mensagem;

            if (mensagensDeErro)
                mensagem = mensagensDeErro.split(',').join('<br />');
            else
                mensagem = 'Desculpe, ocorreu um erro interno. Tente novamente ou contate o suporte';

            this.exibirMensagemDeErro(mensagem);
        },
        exibirMensagemDeSucesso(mensagem) {
            let estiloDaMensagem = 'sucesso';
            let tituloDaMensagem = 'Concluído'
            this.exibirMensagem(mensagem, estiloDaMensagem, tituloDaMensagem);
        },
        exibirMensagemDeErro(mensagem) {
            let estiloDaMensagem = 'erro';
            this.exibirMensagem(mensagem, estiloDaMensagem);
        },
        exibirMensagem(mensagem, estiloDaMensagem, tituloDaMensagem) {
            this.mensagemVisivel = true;
            this.textoMensagem = mensagem;
            this.estiloMensagem = estiloDaMensagem;
            this.tituloMensagem = tituloDaMensagem || '';
            setTimeout(() => { this.fecharMensagem() }, 10000);
        },
        fecharMensagem() {
            this.mensagemVisivel = false;
        },
        limparFiltros() {
            this.filtro = {
                nome: '',
                cpf: '',
                dataDeAssinaturaDoContrato: null
            }
        },
        abrirModalDeAssinaturaDoContrato(solicitacao) {
            this.solicitacaoSelecionada = {
                id: solicitacao.Id,
                nome: solicitacao.Nome,
                cpf: solicitacao.Cpf,
                dataDeAssinaturaDoContrato: null
            };

            this.modalDeAssinaturaDoContratoEstaVisivel = true
        },
        abrirModalDeRegistroDoContrato(solicitacao) {
            this.solicitacaoSelecionada = {
                id: solicitacao.Id,
                nome: solicitacao.Nome,
                cpf: solicitacao.Cpf,
                dataDeAssinaturaDoContrato: null,
                dataDeRegistroDoContrato: null
            };

            this.modalDeRegistroDoContratoEstaVisivel = true
        },
        fecharModalDeAssinaturaDoContrato() {
            this.modalDeAssinaturaDoContratoEstaVisivel = false;
            this.ehResponsavelPelaAssinaturaDoContrato = false;
        },
        fecharModalDeRegistroDoContrato() {
            this.modalDeRegistroDoContratoEstaVisivel = false;
            this.ehResponsavelPeloRegistroDoContrato = false;
        },
        abrirModalDeCancelamento(solicitacao) {
            this.solicitacaoSelecionada = {
                id: solicitacao.Id
            };

            this.modalDeCancelamentoEstaVisivel = true;
        },
        fecharModalDeCancelamento() {
            this.modalDeCancelamentoEstaVisivel = false;
            this.justificativa = null;
        },
        limparSolicitacaoSelecionada() {
            this.solicitacaoSelecionada = {
                id: null,
                nome: '',
                cpf: '',
                dataDeAssinaturaDoContrato: null,
                dataDeRegistroDoContrato: null
            };
        },
        obterClasseCssDaEtapaDoContrato(etapaDoContrato) {
            return etapaDoContrato ?
                etapaDoContrato.toLowerCase().replace("ã", "a").replace("í", "i").split(" ").join("-") :
                etapaDoContrato;
        }
    }
}
</script>


// WEBPACK FOOTER //
// ListaDeSolicitacoesParaGerenciamentoDoContrato.vue?83897d3a